import { render, staticRenderFns } from "./ApplicantInfo.vue?vue&type=template&id=25b7b348&scoped=true"
import script from "./ApplicantInfo.vue?vue&type=script&lang=js"
export * from "./ApplicantInfo.vue?vue&type=script&lang=js"
import style0 from "./ApplicantInfo.vue?vue&type=style&index=0&id=25b7b348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7b348",
  null
  
)

export default component.exports